/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ContentItemProperties } from '@/data/types/Slot';
import store_locator from '@/data/childContent/store_locator';
import store_locator_city from '@/data/childContent/store_locator_city';
import store_locator_street from '@/data/childContent/store_locator_street';
import return_order from '@/data/childContent/return_order';
import cart from '@/data/childContent/cart';
import lego_loyalty from '@/data/childContent/lego_loyalty';
import checkout_header from '@/data/childContent/checkout_header';
import account from '@/data/childContent/account';
import revoke_order from '@/data/childContent/revoke_order';

export const childContentManifestCustom: {
	[key: string]: ContentItemProperties[];
} = {
	store_locator,
	store_locator_city,
	store_locator_street,
	return_order,
	cart,
	lego_loyalty,
	checkout_header,
	account,
	revoke_order
};